export const ROW_DRAG_AREA_WIDTH = 40;
export const ROW_SIDE_PADDING_SIZE = 10;
export const DEFAULT_ROW_CELL_SIZE = 100;
export const ROW_HEIGHT = 40;

export const LIST_ITEM_NAME_CELL_ID = 'LIST_ITEM_NAME_CELL_ID';
export const NEW_ITEM_PLACEHOLDER_ROW_ID = 'NEW_ITEM_PLACEHOLDER_ROW_ID';
export const ADD_NEW_ROW_ID_PREFFIX = 'ADD_NEW_ROW-';
export const ADD_NEW_GROUP_ID = 'ADD_NEW_GROUP_ID';
